import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Helmet from "react-helmet";
import Loader from "../../Components/Loader";

const Container = styled.div`
  height: calc(100vh - 50px);
  width: 100%;
  position: relative;
  padding: 50px;
`;

const Backdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${(props) => props.bgImage});
  background-position: center center;
  background-size: cover;
  filter: blur(3px);
  opacity: 0.5;
  z-index: 0;
`;

const Content = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  z-index: 1;
  height: 100%;
`;

const Cover = styled.div`
  width: 30%;
  background-image: url(${(props) => props.bgImage});
  background-position: center center;
  background-size: cover;
  height: 100%;
  border-radius: 5px;
  margin-right: 30px;
`;

const Data = styled.div`
  width: 70%;
  margin-left: 10px;
`;

const Title = styled.h3`
  font-size: 50px;
  vertical-align: middle;
`;

const ItemContainer = styled.div`
  margin: 20px 0;
`;

const Item = styled.span`
  font-size: 30px;
`;

const Divider = styled.span`
  margin: 0 10px;
  font-size: 30px;
`;

const Overview = styled.p`
  font-size: 18px;
  opacity: 0.7;
  line-height: 1.5;
  width: 50%;
`;

const IMDB = styled.div`
  background-color: #eec100;
  color: black;
  padding: 3px;
  font-size: 18px;
  border-radius: 10px;
  font-weight: 600;
  margin-left: 10px;
  margin-top: 5px;
`;

const TITLECONTAINER = styled.div`
  display: flex;
  align-items: center;
`;

const NICEBUTTON = styled.button`
  all: unset;
  padding: 10px;
  font-size: 20px;
  margin: 15px;
  margin-left: 0px;
  background-color: #eec100;
  color: black;
  border-radius: 10px;
  cursor: pointer;
`;

const DetailPresenter = ({
  result,
  loading,
  error,
  currentIndex,
  content,
  setIndex,
}) =>
  loading ? ( //주의 : HomePresenter와 비교했을 때 jsx안에 들어가면 변수 사용할 때 {}사용 밖이면 안 사용
    <>
      <Helmet>
        <title>Loading | Nomflix</title>
      </Helmet>
      <Loader />
    </>
  ) : (
    <Container>
      <Helmet>
        <title>
          {result.original_title ? result.original_title : result.original_name}{" "}
          | Nomflix
        </title>
      </Helmet>
      <Backdrop
        bgImage={`https://image.tmdb.org/t/p/original${result.backdrop_path}`}
      />
      <Content>
        <Cover
          bgImage={
            result.poster_path
              ? `https://image.tmdb.org/t/p/original${result.poster_path}`
              : "/noPosterSmall.png"
          }
        />
        <Data>
          <TITLECONTAINER>
            <Title>
              {result.original_title
                ? result.original_title
                : result.original_name}
            </Title>
            <a href={`https://www.imdb.com/title/${result.imdb_id}`}>
              <IMDB>IMDb</IMDB>
            </a>
          </TITLECONTAINER>
          <ItemContainer>
            <Item>
              {result.release_date
                ? result.release_date.substring(0, 4)
                : result.first_air_date.substring(0, 4)}
            </Item>
            <Divider>•</Divider>
            <Item>
              {result.runtime ? result.runtime : result.episode_run_time[0]} min
            </Item>
            <Divider>•</Divider>
            <Item>
              {result.genres &&
                result.genres.map((genre, index) =>
                  index === result.genres.length - 1
                    ? genre.name
                    : `${genre.name} / `
                )}
            </Item>
          </ItemContainer>
          <Overview>{result.overview}</Overview>
          <div>
            {content.map((section, index) => (
              <NICEBUTTON onClick={() => setIndex(index)}>
                {section.tab}
              </NICEBUTTON>
            ))}
            <div>{content[currentIndex].content}</div>
          </div>
        </Data>
      </Content>
    </Container>
  );

DetailPresenter.propTypes = {
  result: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.string,
};

export default DetailPresenter;
